import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { VerifyForm } from '@/components/VerifyForm';
import { QUERY_KEYS } from '@/query/queryKeys';
import { VERIFF_CODES } from '@/helpers/constants';
import { APP_LINKS } from '@/helpers/links';
import { useUserStore } from '@/store/userStore';
import { setUserVeriffSkipReason } from '@/store/services/userServices';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import { MyLink } from '@scramble/ui';
import { SKIP_REASON_TYPES } from './constants';
import { clearTempUserData } from '../../utils';
import s from './index.module.scss';

export const StepVeriff = () => {
  const accessToken = useUserStore(state => state.accessToken);
  const { t  } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const  { closeModal } = useModal();

  useEffect(() => {
    if (!accessToken) {
      clearTempUserData();
      window.location.reload();
    }
  }, [accessToken]);

  if (!accessToken) return null;

  return (
    <div className={s.wrapper}>
      <VerifyForm
        source="registration"
        onSuccess={() => {
          clearTempUserData();
          queryClient.setQueryData([QUERY_KEYS.user.veriff_status], () => ({
            code: VERIFF_CODES.submitted,
          }));
          closeModal(MODAL_IDS.country_verification);
          navigate(APP_LINKS.dashboard);
        }}
      />
      <div className={s.actions}>
        <MyLink
          href={APP_LINKS.dashboard}
          onClick={() => {
            clearTempUserData();
            setUserVeriffSkipReason(SKIP_REASON_TYPES.skipped_later);
          }}
        >
          {t('auth:step_veriff.complete_verification_later')}
        </MyLink>
        <MyLink
          href={APP_LINKS.dashboard}
          onClick={() => {
            clearTempUserData();
            setUserVeriffSkipReason(SKIP_REASON_TYPES.skipped_dont_want);
          }}
        >
          {t('auth:step_veriff.dont_want_to_be_verified')}
        </MyLink>
      </div>
    </div>
  );
};
